import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="SPIN THE WHEEL AND GET FREESPINS"
            highlights={[{ word: 'FREESPINS' }]}
            breakAfterWords={['WHEEL']}
            className={styles.text_header}
        />
    )
}
